<template>
    <div>
        <div class="start-modal-remarks-div">
            <el-icon class="el-input__icon"><CircleCheckFilledIcon /></el-icon>
            <span>{{ $trans('web_search.checkout_start_modal_side.info_1') }}</span>
        </div>
        <div class="start-modal-remarks-div">
            <el-icon class="el-input__icon"><CircleCheckFilledIcon /></el-icon>
            <span>{{ $trans('web_search.checkout_start_modal_side.info_2') }}</span>
        </div>
        <div class="start-modal-remarks-div">
            <el-icon class="el-input__icon"><CircleCheckFilledIcon /></el-icon>
            <span>{{ $trans('web_search.checkout_start_modal_side.info_3') }}</span>
        </div>
        <div class="start-modal-remarks-div">
            <el-icon class="el-input__icon"><CircleCheckFilledIcon /></el-icon>
            <span>{{ $trans('web_search.checkout_start_modal_side.info_4') }}</span>
        </div>
    </div>
</template>

<script>
import { CircleCheckFilled as CircleCheckFilledIcon } from '@element-plus/icons-vue'

export default {
    components: {
        CircleCheckFilledIcon,
    },
}
</script>

<style scoped>
.start-modal-remarks-div {
    padding-bottom: 15px;
    display: flex;
    align-items: center;
}

.start-modal-remarks-div :deep(.el-icon),
.start-modal-remarks-div :deep(.el-icon svg) {
    height: 1.5em;
    width: 1.5em;
}

.start-modal-remarks-div :deep(.el-icon svg path) {
    fill: #41ABC4;
}

.start-modal-remarks-div span {
    color: #3C3C3C;
    font: normal normal 500 14px/17px Barlow;
    margin-left: 10px;
}
</style>